import { useMemo } from 'react';

import EloomiLogoIcon from '@/common/components/shared/icons/__generated__/EloomiLogo';
import GithubLogoIcon from '@/common/components/shared/icons/__generated__/GithubLogo';
import GoogleLogoIcon from '@/common/components/shared/icons/__generated__/GoogleLogo';
import GreenhouseLogoIcon from '@/common/components/shared/icons/__generated__/GreenhouseLogo';
import HubspotLogoIcon from '@/common/components/shared/icons/__generated__/HubspotLogo';
import SlackLogoIcon from '@/common/components/shared/icons/__generated__/SlackLogo';
import { EmployeeExternalAccountType } from '@/common/graphql';

interface Props {
  accountType: EmployeeExternalAccountType | null | undefined;
}

export const ExternalAccountIcon = ({ accountType }: Props) => {
  const icon = useMemo(() => {
    switch (accountType) {
      case EmployeeExternalAccountType.Google:
        return <GoogleLogoIcon />;
      case EmployeeExternalAccountType.Greenhouse:
        return <GreenhouseLogoIcon />;
      case EmployeeExternalAccountType.Hubspot:
        return <HubspotLogoIcon />;
      case EmployeeExternalAccountType.Slack:
        return <SlackLogoIcon />;
      case EmployeeExternalAccountType.Eloomi:
        return <EloomiLogoIcon />;
      case EmployeeExternalAccountType.Github:
        return <GithubLogoIcon />;
      default:
        return <div className="size-4" />;
    }
  }, [accountType]);

  return <>{icon}</>;
};
